import { NavigationPage } from '@/app/components'
import { Button, Text } from '@/components'
import RadioButton from '@/components/forms/RadioButton'
import { ButtonContainer } from '../../ava/BrandedPage'
import { useState } from 'react'
import { useNavigation } from '@/app/hooks'
import { useSurveyResponder } from '@/app/components/SurveyObserver/reducer'
import { useParams } from 'react-router-dom'
import SurveyObserver from '@/app/components/SurveyObserver'

export default function VehicleIneligiblePage() {
  const [surveyYes, setSurveyYes] = useState(true)
  const { make } = useParams<{ make: string }>()
  const navigate = useNavigation()
  const { addSurveyInteraction } = useSurveyResponder('BrandApology')

  const onSubmit = async () => {
    addSurveyInteraction({
      action: 'click',
      action_data: {
        notify: surveyYes,
        make: make,
        reason: 'ineligible',
      },
    })

    navigate.goBackWithParam('showAlert=true')
  }

  return (
    <NavigationPage
      id="vehicle ineligible page"
      title="Ineligible brand for this program"
      subtitle="It looks like this brand isn't eligible for this program. However, it may become eligible in the future."
    >
      <SurveyObserver observedSurveys={['BrandApology']}>
        <NavigationPage.SingleCardContent>
          <div className="flex flex-col gap-4">
            <Text variant="body1">
              Would you like to be notified when this brand becomes eligible for
              this program?
            </Text>
            <div
              className="flex flex-row gap-2 cursor-pointer"
              onClick={() => setSurveyYes(true)}
            >
              <RadioButton checked={surveyYes} />
              <Text variant="body2">Yes</Text>
            </div>
            <div
              className="flex flex-row gap-2 cursor-pointer"
              onClick={() => setSurveyYes(false)}
            >
              <RadioButton checked={!surveyYes} />
              <Text variant="body2">No</Text>
            </div>
          </div>
          <ButtonContainer>
            <Button
              id="submit"
              type="submit"
              variant="primary"
              onClick={onSubmit}
            >
              Submit
            </Button>
          </ButtonContainer>
        </NavigationPage.SingleCardContent>
      </SurveyObserver>
    </NavigationPage>
  )
}
